export const ENV = {
  APP_PROJECT: import.meta.env.VITE_APP_PROJECT || 'famecreator',
  API_URL: import.meta.env.VITE_API_URL || '/api',
  APP_NAME: import.meta.env.VITE_APP_NAME || 'FameCreator',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  NSFW: import.meta.env.VITE_NSFW === 'true',
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || '',
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
  STRIPE_WEBHOOK_ENDPOINT: import.meta.env.VITE_STRIPE_WEBHOOK_ENDPOINT || '',
  APP_URL: import.meta.env.VITE_APP_URL || '',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',
  DUB_PUBLISHABLE_KEY: import.meta.env.VITE_DUB_PUBLISHABLE_KEY || '',
  RUDDERSTACK_WRITE_KEY: import.meta.env.VITE_RUDDERSTACK_WRITE_KEY || '',
  RUDDERSTACK_DATA_PLANE_URL: import.meta.env.VITE_RUDDERSTACK_DATA_PLANE_URL || '',
  NODE_ENV: import.meta.env.MODE || 'development',
  APP_STAGE: import.meta.env.VITE_APP_STAGE || 'dev',
} as const;
